export const CURRENT_WEBSITE_FORM_DATA = {
	monthlyTraffic: 5000,
	conversionRate: 1,
	clothingRate: 30,
	avgMRR: 250,
	retention: 16,
	qualifiedLeads: 5000 * (1 / 100),
	customers: (5000 * (1 / 100)) / (100 / 30),
}

export const NEW_WEBSITE_FORM_DATA = {
	monthlyTraffic: 5000,
	conversionRate: 2,
	clothingRate: 30,
	avgMRR: 250,
	retention: 16,
	qualifiedLeads: 5000 * (1 / 100),
	customers: (5000 * (2 / 100)) / (100 / 30),
}

export const INVESTMENT_FORM_DATA = {
	amount: 20000,
	frequency: 'oneTime',
	duration: 100,
	delay: 2,
}


export const appContextValues = {
	currentWebsiteFormData: CURRENT_WEBSITE_FORM_DATA,
	setcurrentWebsiteFormData: () => {},
	newWebsiteFormData: NEW_WEBSITE_FORM_DATA,
	setnewWebsiteFormData: () => {},
	investmentFormData: INVESTMENT_FORM_DATA,
	setinvestmentFormData: () => {},
	monthsForChart: 12,
	setmonthsForChart: () => {},
	setTableValues: () => {},
	tableValues: [],
	chartsValues: [],
}
